import { useEffect, useState } from "react";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Modal } from "antd";
import { setAllMeetingRooms } from "../../redux/actions/mainAction";
import noitem from "../../images/noitem.gif";

const { confirm } = Modal;

const MeetingRoomsTable = () => {
  const dispatch = useDispatch();
  const { GlobalResponse } = useSelector((state) => state);
  const { MainResponse } = useSelector((state) => state);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    getMeetingRooms();
  }, [GlobalResponse.triggeranyevent]);

  const getMeetingRooms = async () => {
    try {
      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/get-meetingrooms/?page=${page}`,
        {
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      if (result) {
        dispatch(setAllMeetingRooms(result.meetingRooms));
        setTotalPages(result.totalPages);
      }
    } catch (error) {}
  };

  const showDeleteConfirm = (meetingRoomName, _id) => {
    confirm({
      centered: "centered",
      title: meetingRoomName,
      icon: <ExclamationCircleFilled />,
      content: "Otağl silmək istədiyinizdən əminsiniz?",
      okText: "Sil",
      okType: "danger",
      cancelText: "İmtina Et",
      onOk() {
        deleteMeetingRoom(_id);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const deleteMeetingRoom = async (_id) => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/meetingroom/${_id}`,
      {
        method: "delete",
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    console.log(result);
    if (result) {
      getMeetingRooms();
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  return (
    <>
      {MainResponse.allMeetingRooms?.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Otağın adı</th>
              <th>Şirkət</th>
              <th>Otağın Tutumu</th>
              <th>E-poçt</th>
              <th>Əməliyyat</th>
            </tr>
          </thead>
          {MainResponse.allMeetingRooms.map((meetingRoom, index) => (
            <tbody key={meetingRoom._id}>
              <tr>
                <td>{meetingRoom._id}</td>
                <td>{meetingRoom.meetingRoomName}</td>
                <td>{meetingRoom.companyName}</td>
                <td>{meetingRoom.meetingRoomSize}</td>
                <td>{meetingRoom.meetingRoomEmail}</td>
                <td>
                  <Link
                    state={{ id: meetingRoom._id }}
                    className="btn"
                    to="/meetingroomedit"
                  >
                    {<BiEdit />}
                  </Link>

                  <Link
                    onClick={() =>
                      showDeleteConfirm(
                        meetingRoom.meetingRoomName,
                        meetingRoom._id
                      )
                    }
                    className="btn-del"
                  >
                    {<AiFillDelete />}
                  </Link>
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      ) : (
        <div className="no-item">
          <Row>
            <Col span={24}>
              <div className="no-item">
                <img style={{ width: "342px" }} src={noitem} alt="noitem" />
              </div>
            </Col>
          </Row>
        </div>
      )}

      {totalPages > 0 && (
        <div className="pagination">
          <button
            disabled={page === 1}
            onClick={() => handlePageChange(page - 1)}
          >
            Əvvəlki
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              className={page === index + 1 ? "active" : ""}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            disabled={page === totalPages}
            onClick={() => handlePageChange(page + 1)}
          >
            Növbəti
          </button>
        </div>
      )}
    </>
  );
};

export default MeetingRoomsTable;
